var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorisNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9926 0C21.6634 0 22.2759 0.355469 22.5676 0.922852L27.5697 10.582L38.7405 12.127C39.3968 12.2158 39.9436 12.6465 40.1478 13.2412C40.352 13.8359 40.1843 14.4785 39.7176 14.916L31.6166 22.4492L33.527 33.0859C33.6363 33.7012 33.3666 34.3232 32.8197 34.6924C32.2728 35.0615 31.5582 35.1025 30.9749 34.8086L20.9853 29.8047L11.0103 34.8018C10.4197 35.0957 9.7051 35.0547 9.16552 34.6856C8.62593 34.3164 8.34885 33.6943 8.45823 33.0791L10.3686 22.4424L2.2676 14.916C1.79364 14.4785 1.63323 13.8291 1.83739 13.2412C2.04156 12.6533 2.58843 12.2227 3.24468 12.127L14.4155 10.582L19.4176 0.922852C19.7166 0.355469 20.3218 0 20.9926 0ZM20.9926 5.40039L17.1645 12.7969C16.9093 13.2822 16.4207 13.624 15.8447 13.7061L7.21864 14.8955L13.4822 20.7129C13.8832 21.0889 14.0728 21.6221 13.978 22.1484L12.4978 30.3311L20.1686 26.4893C20.6864 26.2295 21.3061 26.2295 21.8166 26.4893L29.4874 30.3311L28.0145 22.1553C27.9197 21.6289 28.102 21.0957 28.5103 20.7197L34.7738 14.9023L26.1478 13.7061C25.5791 13.624 25.0832 13.2891 24.828 12.7969L20.9926 5.40039Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_1481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorisNotSelected);
export default __webpack_public_path__ + "static/media/FavorisNotSelected.e2fdc313b17501c16d99e521fbafd8a7.svg";
export { ForwardRef as ReactComponent };